import { render, staticRenderFns } from "./RegisteredByRegion.vue?vue&type=template&id=8f57b5c6"
import script from "./RegisteredByRegion.vue?vue&type=script&lang=js"
export * from "./RegisteredByRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports